var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGovernmentoffice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1210 1210",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M791.68 1017.63V482.86h-36.33c-2.7-94.3-32.2-183.5-116.23-205.39-4.95-39.37-17.57-139.91-18.23-146.4-.94-9.4-8.44-26.07-23.4-26.07-17.66 0-19.8 19.02-21.2 27.48-1.15 6.89-13.04 107.7-17.4 144.83-85.35 23.65-109.7 127.53-111.9 205.55h-35.18v534.77h-88.36V1105h563.1v-87.37zM600.55 528.65a66.97 66.97 0 0 1 66.96 67.06c0 37.1-29.92 67.13-66.96 67.13a67.06 67.06 0 0 1-67.08-67.13c0-37.04 30-67.06 67.08-67.06z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovernmentoffice);
export default __webpack_public_path__ + "static/media/Government office.e9508e6fb2545b0823f130330205bd19.svg";
export { ForwardRef as ReactComponent };